import { PubSubService } from '../_shared/pubSubServiceInterface';

class SidePanelService extends PubSubService {
  public static readonly EVENTS = {
    PANEL_DATA_CHANGE: 'event::panelDataChanged',
  };

  public static REGISTRATION = {
    name: 'sidePanelService',
    altName: 'SidePanelService',
    create: ({ configuration = {} }) => {
      return new SidePanelService();
    },
  };

  serviceImplementation = {};

  constructor() {
    super(SidePanelService.EVENTS);
    this.serviceImplementation = {};
  }

  public setServiceImplementation({
    getState: getStateImplementation,
    setPanelData: setPanelDataImplementation,
    closePanel: closePanelImplementation,
    openPanel: openPanelImplementation,
  }): void {
    if (getStateImplementation) {
      this.serviceImplementation._getState = getStateImplementation;
    }
    if (setPanelDataImplementation) {
      this.serviceImplementation._setPanelData = setPanelDataImplementation;
    }
    if (closePanelImplementation) {
      this.serviceImplementation._closePanel = closePanelImplementation;
    }
    if (closePanelImplementation) {
      this.serviceImplementation._openPanel = openPanelImplementation;
    }
  }

  public setPanelData({ panelName, open }) {
    const res = this.serviceImplementation._setPanelData({ panelName, open });
    this._broadcastEvent(this.EVENTS.PANEL_DATA_CHANGE, { open: open });
    return res;
  }

  public getState() {
    return this.serviceImplementation._getState();
  }

  public closePanel() {
    const res = this.serviceImplementation._closePanel();
    this._broadcastEvent(this.EVENTS.PANEL_DATA_CHANGE, { open: false });
    return res;
  }

  public openPanel() {
    const res = this.serviceImplementation._openPanel();
    this._broadcastEvent(this.EVENTS.PANEL_DATA_CHANGE, { open: true });
    return res;
  }
}

export default SidePanelService;
